import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import SideBar from './SideBar/SideBar';
import ReportHeader from './ReportHeader/ReportHeader';
import ReportContent from './ReportContent/ReportContent';
import ReportFooter from './ReportFooter/ReportFooter';
import NavLinkList from './NavLinkList/NavLinkList';
import Collapse, {Panel} from 'rc-collapse';
import './Report.css';
import reportData from '../../data/reportData.json';

import firebase from '../../firebase';
import {history} from "../../history";
import * as routes from '../../constants/routes';
import Loading from "../Loading/Loading";
import utility from '../../utility/utility';


class Report extends Component {

    state = {
        mobileNavTitle: null,
        mobileHeaderStatus: true,
        reportData: reportData.vata,
        mobileNavMenuStatus: '1',
        vata: 0,
        pitta: 0, 
        kapha: 0,
        loggedIn: false,
        loaded: false
    };

    //componentWillMount(){}

    componentDidUpdate(prevProps, prevState) {

        let newMobileTitle = window.location.pathname.slice(8).replace(/-/g, ' ');

        if(newMobileTitle){
            newMobileTitle = newMobileTitle[0].toUpperCase() + newMobileTitle.slice(1);
        } else {
            newMobileTitle = 'Overwiew';
        }

        if (prevState.mobileNavTitle !== newMobileTitle) {
            this.setState({
                mobileNavTitle: newMobileTitle
            });
        }
    }
    
    componentDidMount() {

        firebase.auth().onAuthStateChanged((user) => {

            if (user) {

                const currentUser = firebase.auth().currentUser;

                firebase.database().ref('user_reports/' + currentUser.uid).once('value').then((snapshot) => {

                    const reportDatabaseData = snapshot.val();

                    let vpk_percentages = reportDatabaseData.vpk_percentages.match(/[0-9]{1,3}-[0-9]{1,3}-[0-9]{1,3}/)[0].split("-");

                    let yogaType = reportDatabaseData.report_yoga_type;

                    /*
                    * right now only show only one major body type report
                    * apply formatting for composite body type report
                    * @todo enable composite body type report
                    * */
                    // let yogaTypeComposite = yogaType.split("-").length;
                    // // if composite length is 1 then no problem
                    // if(yogaTypeComposite === 2){
                    //     if(yogaType === "pitta-vata"){
                    //         yogaTypeFormatted = "vata-pitta";
                    //     } else if(yogaType === "kapha-vata"){
                    //         yogaTypeFormatted = "vata-kapha";
                    //     } else if(yogaType === "kapha-pitta"){
                    //         yogaTypeFormatted = "pitta-kapha";
                    //     }
                    // } else if(yogaTypeComposite === 3){
                    //     yogaTypeFormatted = "vata-pitta-kapha";
                    // }

                    /*
                    * for now, extract major body type
                    * @todo remove it for composite body type report
                    * */
                    yogaType = yogaType.split('-')[0];

                    //console.log(yogaType);

                    let userName = utility.toTitleCase(reportDatabaseData.user_name);

                    this.setState({
                        loggedIn: true,
                        loaded: true,
                        reportData: reportData[yogaType] || reportData.vata,
                        vata: vpk_percentages[0],
                        pitta: vpk_percentages[1],
                        kapha: vpk_percentages[2],
                        name: userName,
                        type: yogaType
                    });

                })
                .catch(err => {
                    console.log(err);
                    history.push(routes.SIGN_IN);
                });

            } else {
                // user sign out
                history.push(routes.SIGN_IN);
            }

        });


        let currentScrollY = window.scrollY;
        window.addEventListener('scroll', () => {
            let mobileHeaderStatus = window.scrollY > currentScrollY;
            currentScrollY = window.scrollY;
            this.setState({mobileHeaderStatus: !mobileHeaderStatus});
        });
   }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    setMobileNavTitle = (e) => {
        this.setState({
            mobileNavTitle: e.target.innerText
        });

        this.toggleMobileMenu();
    };

    toggleMobileMenu = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                mobileNavMenuStatus: this.state.mobileNavMenuStatus === '1' ? '0' : '1'
            } 
        });
    };

    render() {

        const {
            mobileNavTitle,
            mobileHeaderStatus,
            reportData,
            vata,
            pitta,
            kapha,
            name,
            type
        } = this.state;

        if (!this.state.loaded) return (<Loading />);

        return (
            <div className="report-container" id="outer-container">
                <section className="report-container__menu-area">
                    <SideBar bodyType={type} pagesData={reportData} name={name}/>
                </section>

                <section className="report-container__content-area">
                    <div className={`report-container__header-wrapper ${mobileHeaderStatus ? '' : 'report-container__header-inVisible'}`}>
                        <ReportHeader />

                        <div className="report-container__mobile-nav"
                             onClick={this.toggleMobileMenu}>
                            <Collapse activeKey={this.state.mobileNavMenuStatus}>
                                <Panel header={mobileNavTitle} onClick={this.setMobileNavTitle}>
                                    <NavLinkList 
                                        pagesData={reportData} 
                                        getTitle={this.setMobileNavTitle}
                                    />
                                </Panel>        
                            </Collapse>
                        </div>
                    </div>

                    <div id="page-wrap" style={{flex: 1}}>
                        <div className="report-container__content-main">
                            <ReportContent
                                location={this.props.location} 
                                pagesData={reportData}
                                vata={vata}
                                pitta={pitta}
                                kapha={kapha}
                                name={name}
                                type={type}
                            />
                        </div>
                    </div>

                    { /* <div className="report-container__mobile-links"> 
                        <NavLinkList pagesData={reportData}/>
                    </div> */ }

                    <ReportFooter/>
                </section>
            </div>
        );
    }
}

export default Report;


// WEBPACK FOOTER //
// ./src/components/Report/Report.js